import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { post } from "aws-amplify/api";

export default function SubscriptionBanner({ authorUsername, authorName, className = "" }) {
  const { user } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  
  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email.trim() || !email.includes('@')) {
      alert("Please enter a valid email address");
      return;
    }
    
    setIsSubmitting(true);
    try {
      await post({
        apiName: 'userApi',
        path: '/subscribe',
        options: {
          body: {
            email,
            authorUsername
          }
        }
      });
      
      setSubscribed(true);
      setEmail("");
    } catch (error) {
      console.error("Error subscribing:", error);
      alert("Failed to subscribe. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  // Don't show subscription banner on own articles
  if (user && user.username === authorUsername) {
    return null;
  }
  
  return (
    <div className={`bg-taupe/10 rounded-lg p-6 ${className}`}>
      {subscribed ? (
        <div className="text-center">
          <h3 className="text-xl font-serif mb-2">Thanks for subscribing!</h3>
          <p className="text-gray-700">
            You'll receive updates when {authorName} publishes new articles.
          </p>
        </div>
      ) : (
        <>
          <h3 className="text-xl font-serif mb-2">
            Subscribe to {authorName}'s newsletter
          </h3>
          <p className="text-gray-700 mb-4">
            Get the latest articles delivered right to your inbox.
          </p>
          
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              className="flex-grow px-4 py-2 border rounded-lg focus:ring-1 focus:ring-taupe focus:border-taupe"
              required
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 bg-taupe text-white rounded-lg hover:bg-taupe-dark disabled:opacity-50"
            >
              {isSubmitting ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
          
          <p className="text-xs text-gray-500 mt-2">
            No spam. Unsubscribe at any time.
          </p>
        </>
      )}
    </div>
  );
}